import { ChargeCodeSource, ChargeCode } from '../type/chargeCodeType';
import { mapGroupType } from './gqlProductCategortyToDomainMapper';
import {
  GetChargeCodeResponse as GQLChargeCode,
  ChargeCodeSource as GQLChargeCodeSource,
} from 'graphql-query-contracts';

const mapChargeCodeSource: Record<GQLChargeCodeSource, ChargeCodeSource> = {
  [GQLChargeCodeSource.ChargeCodeSourceActivate]: ChargeCodeSource.Activate,
  [GQLChargeCodeSource.ChargeCodeSourceIntegration]:
    ChargeCodeSource.Integration,
};

export function mapGqlChargeCodeToDomainChargeCode(
  chargeCode: GQLChargeCode
): ChargeCode {
  return {
    id: chargeCode.id,
    chargeCode: chargeCode.chargeCode,
    chargeCodeSource: mapChargeCodeSource[chargeCode.chargeCodeSource],
    description: chargeCode.description ?? undefined,
    glCode: chargeCode.glCode,
    groupId: chargeCode.groupId,
    groupType: mapGroupType(chargeCode.groupType),
  };
}
